import { server } from '../server';
import { AccessTokenStore } from './accessTokenStore';
export const login = async ({ walletAddress, signature, timestamp, }) => {
    const response = await server.post({ endpoint: 'user/login' }, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            wallet_address: walletAddress.toLowerCase(),
            signature: signature,
            timestamp: timestamp,
        }),
    });
    if (!response.ok) {
        throw new Error(`Error logging in: ${response.statusText}`);
    }
    const data = await response.json();
    const accessTokenStore = AccessTokenStore.getInstance();
    accessTokenStore.accessToken = data.access_token;
    return { success: true };
};
